class Bundle {
  constructor() {
    this.bundleJsonContainer = document.querySelector('#bundle-json')
    if (this.bundleJsonContainer) {
      this.bundleJSON = JSON.parse(this.bundleJsonContainer.innerHTML)
      this.bundleProducts = this.bundleJSON.products
      this.bundleItemsWrapper = document.querySelector('[data-bundle-items-container]')
      this.bundleItemsMobileWrapper = document.querySelector('[data-bundle-items-mobile-container]')
      this.bundleContainer = this.bundleItemsWrapper.querySelector('[data-bundle-items]')
      this.bundleContainerMobile = this.bundleItemsMobileWrapper?.querySelector('[data-bundle-items-mobile]')
      this.init()
      this.events()
    }
  }

  //--------------------------------------
  // register events handlers
  //--------------------------------------
  events() {
    // checkboxes
    window.addEventListener(
      'load',
      function () {

    }.bind(this)


    )
  } //events()

  //--------------------------------------
  // Render bundle items
  //--------------------------------------
  renderBundleItems() {

    for (var i = 0; i < this.bundleProducts.length; i++) {
      var product = this.bundleProducts[i]
      var item = document.createElement('div')
      item.classList.add('bundle-item')
      var productTitle = product.product_title
      var variantTitle = product.variant_title
      var featuredImage = product.product_images[0].src
      var variantImage = product.variant_featured_image
      var url = product.url
      if (variantTitle.toLowerCase() !== 'default title') {
        item.innerHTML = `
          <div class='bundle-item-inner'>
            <a href='${url}'>
            <div class='bundle-item-img-container'>
              <img class='bundle-item-img' src='${variantImage}' alt='${productTitle}'></div>
              <h6 class='bundle-item-title'>${productTitle} - ${variantTitle}</h6>
            </a>
          </div>
        `
      } else {
        item.innerHTML = `
          <div class='bundle-item-inner'>
            <a href='${url}'>
            <div class='bundle-item-img-container'>
              <img class='bundle-item-img' src='${featuredImage}' alt='${productTitle}'></div>
              <h6 class='bundle-item-title'>${productTitle}</h6>
            </a>
          </div>
        `
      }

      this.bundleContainer?.appendChild(item)

      var itemClone = item.cloneNode(true)
      this.bundleContainerMobile?.appendChild(itemClone)
    }
  }

  //--------------------------------------
  // Check if bundle should be OOS
  //--------------------------------------
  bundleOOS() {
    this.bundleWrap = document.querySelector("[data-bundle-wrap]")
    var regularATC = this.bundleWrap.querySelector("[data-content-available]")
    var soldoutATC = this.bundleWrap.querySelector('[data-content-soldout]')
    var qtySelector = this.bundleWrap.querySelector('[data-variant-qty-wrap]')
    var productInfo = this.bundleWrap.querySelector("[data-product-info]")
    var bundleOOS = this.bundleJSON.bundle_OOS

    if (bundleOOS) {
      regularATC.classList.add('hide')
      soldoutATC.classList.remove('hide')
      qtySelector.classList.add('hide')

      // coming soon badge
      var comingSoonEl = this.bundleWrap.querySelector('[data-badge1]')

      if (!comingSoonEl) {
        var comingSoonBadge = document.createElement('div')
        comingSoonBadge.innerHTML = 'Coming Back Soon'
        comingSoonBadge.classList.add('badge1')
        comingSoonBadge.setAttribute('data-badge1', true)
        productInfo.prepend(comingSoonBadge)
      }
    }
  }

  //--------------------------------------
  // load()
  //--------------------------------------
  load() {
    this.renderBundleItems()
    this.bundleOOS()
  }

  init() {
    document.addEventListener('shopify:section:load', this.load)

    try {
      this.load()
    } catch (err) {
      console.error(err)
    }
  }
}

new Bundle()